<p-toast></p-toast>
<div class="row loginRow">
    
    <span class="imgCont">
        <img src="assets/MicrosoftTeams-image.png" class="imgPosit">
    </span>
    <mat-card class="login-card">
        <mat-card-title class="loginTitle">{{ 'LOGIN_TITLE' | translate }}</mat-card-title>
        <form (ngSubmit)="iniciarSesion()" >
            <mat-card-content>
                <h5 class="customfont1">{{ 'EMAIL' | translate }}</h5>
                <div class="p-field mb-20">
                    <input id="email" type="email" [(ngModel)]="email" class="custom-input" (input)="quitarEspacios($event.target)">
                </div>
                <h5 class="customfont1">{{ 'PASSWORD' | translate }}</h5>
                <div class="p-field mb-20">
                    <input id="password" type="password" [(ngModel)]="password" class="custom-input" #passwordInput >
                    <button type="button" class="password-toggle-btn" style="color: #666;" (click)="togglePasswordVisibility(passwordInput)">
                        <i class="fas" [ngClass]="{'fa-eye-slash': !showPassword, 'fa-eye': showPassword}"></i>
                        {{ 'SHOW_PASSWORD' | translate }}
                    </button>
                </div>
            </mat-card-content>
            <mat-card-subtitle class="loginSubtitle">{{ 'FORGOT_PASSWORD' | translate }} <a (click)="navigateRestarPassword('en')" routerLinkActive="router-link-active" class="customlink">{{ 'RESET_HERE' | translate }}</a></mat-card-subtitle>
            <mat-card-actions>
                <button pButton pRipple type="submit" label="{{ 'LOGIN' | translate }}" class="p-button-rounded loginbutton">
                </button>
            </mat-card-actions>
        </form>
    </mat-card>
</div>